/* jshint ignore:start */

var CertificationsCarouselManager = (function($) {
    // console.log("llamada a config idioma");
    var instance;

    function init() {

        var _$certificationsCarousel;

        return {
            initFlickity: function() {

                var $flickitySlider;

                jQuery('.js-certifications-carousel').each(function () {

                    $flickitySlider = jQuery(this).flickity({
                        // options
                        draggable: true,
                        // cellAlign: 'left',
                        imagesLoaded: true,
                        groupCells: true,
                        contain: true,
                        arrowShape: {
                            x0: 10,
                            x1: 60, y1: 50,
                            x2: 65, y2: 45,
                            x3: 20
                        }
                    });
                });
            },


            init: function() {
                _$certificationsCarousel = $('.js-certifications-carousel');

                if (_$certificationsCarousel.length) {
                    // console.log('noticias carousel inittttt');
                    this.initFlickity();
                }
            }
        };
    }


    return {

        getInstance: function() {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */
